import storageLocal from "@/common/storage"
import { isTablet } from "@/common/util"

export const autoOpenToolbox = (signType: string) => {
  if (isTablet()) {
    return false
  }

  const visitedSigns = JSON.parse(storageLocal.getItem("visitedSigns") || "[]")

  if (visitedSigns.includes(signType)) {
    return false
  }

  return ["wood_sign", "label_plates", "meta_plastic_sign", "meta_name_sign", "door_sign", "house_sign"].includes(
    signType
  )
}

export const setSignTypeVisited = (signType: string) => {
  const visitedSigns = JSON.parse(storageLocal.getItem("visitedSigns") || "[]")

  if (!visitedSigns.includes(signType)) {
    visitedSigns.push(signType)
  }

  storageLocal.setItem("visitedSigns", JSON.stringify(visitedSigns))
}
